import {ProductionDao} from '../../dao';
import {
    ProductionModel,
    ErrorModel
} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_PRODUCTION';

export async function createProduction(
    userData: Record<string, string>,
    production: Record<string, any>
) {
    try {
        const newProduction = ProductionModel.newProduction(production);

        const result = await ProductionDao.createProduction(userData.userToken, newProduction);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
